import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { XMarkIcon } from '@heroicons/react/20/solid';
import { toast } from 'react-toastify';

const YeniKategoriModal = ({ isOpen, onClose, onKategoriEkle, parentKategori = null, parentId = null, duzenlenecekKategori = null }) => {
  const [kategoriAdi, setKategoriAdi] = useState('');
  const [hata, setHata] = useState('');

  useEffect(() => {
    setKategoriAdi(duzenlenecekKategori || '');
    setHata('');
  }, [duzenlenecekKategori, parentKategori, parentId, isOpen]);

  if (!isOpen) return null;

  const baslik = duzenlenecekKategori
    ? 'Kategori Düzenle'
    : parentKategori
      ? 'Yeni Alt Kategori'
      : 'Yeni Kategori';

  const handleSubmit = async (e) => {
    e.preventDefault();
    const ad = kategoriAdi.trim();
    if (!ad) return;
    // 3. argüman (eski isim) düzenleme modunu belirler
    const sonuc = await onKategoriEkle(ad, parentId, duzenlenecekKategori);
    if (sonuc === false) {
      setHata(`"${ad}" kategorisi eklenemedi veya zaten mevcut!`);
      toast.error(`"${ad}" kategorisi eklenemedi veya zaten mevcut!`);
    } else {
      onClose();
    }
  };

  return createPortal(
    <div className="app-modal-overlay">
      <div className="relative w-full max-w-md rounded-2xl border border-slate-200 bg-white shadow-2xl animate-fade-in-up">
        <div className="app-modal-header">
          <h2 className="app-modal-title">{baslik}</h2>
          <button onClick={onClose} className="app-modal-close" aria-label="Kapat">
            <XMarkIcon className="h-5 w-5" />
          </button>
        </div>
        <form onSubmit={handleSubmit} className="app-modal-body">
          {!duzenlenecekKategori && parentKategori && (
            <p className="mb-3 text-sm text-slate-500">
              Üst kategori: <span className="font-medium text-slate-700">{parentKategori}</span>
            </p>
          )}
          <label htmlFor="kategoriAdi" className="app-label">Kategori adı</label>
          <input
            id="kategoriAdi"
            type="text"
            value={kategoriAdi}
            onChange={(e) => { setKategoriAdi(e.target.value); setHata(''); }}
            placeholder="Kategori adı"
            className="app-input"
            autoFocus
          />
          {hata && <p className="mt-2 text-sm text-rose-600">{hata}</p>}
          <div className="mt-5 flex justify-end gap-2">
            <button type="button" onClick={onClose} className="btn-secondary">İptal</button>
            <button type="submit" className="btn-primary">
              {duzenlenecekKategori ? 'Güncelle' : 'Ekle'}
            </button>
          </div>
        </form>
      </div>
    </div>,
    document.body
  );
};

export default YeniKategoriModal;
